// src/app/guards/maintenance.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ConfigService } from '../services/config.service';

@Injectable({ providedIn: 'root' })
export class MaintenanceGuard implements CanActivate {
  constructor(private configService: ConfigService, private router: Router) {}

  canActivate(): boolean {
    console.log('[MaintenanceGuard] canActivate() triggered');

    console.log('Deployment mode is:', this.configService.deploymentMode);

    if (this.configService.deploymentMode) {
      this.router.navigate(['/page-maintenance']);
      return false;
    }
    return true;
  }

}
